
import { Reducer } from 'redux';
import { STATE } from 'app/constants';
import { mergeReducers } from 'app/infrastructure/redux/merge-reducers';
import { withOptionsReducer } from 'app/components/options-handler';
import { ExternalUrlAdminState } from './types-store';
import { reducer as externalUrlsAdminFormReducer, INITIAL_STATE as externalUrlAdminFormState } from './form/reducers';
import { reducer as externalUrlsAdminListReducer, INITIAL_STATE as externalUrlsAdminListState } from './list/reducers';

export const INITIAL_STATE: ExternalUrlAdminState = {
  form: externalUrlAdminFormState,
  list: externalUrlsAdminListState
};

export const reducer: Reducer<ExternalUrlAdminState> = withOptionsReducer(
  STATE.externalUrlAdministration,
  mergeReducers({
    form: externalUrlsAdminFormReducer,
    list: externalUrlsAdminListReducer
  })
);
